import {
  Button,
  Dialog,
  DialogTitle,
  Paper,
  TextField,
  Grid,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/system";
import DoneIcon from "@mui/icons-material/Done";
import { useSelector } from "react-redux";
import { setIsLoading, setUserToken } from "../../../../../features/userSlice";
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { MetaEntitiesEndPointLogic } from "../../../../../logic/Admin/MetaEntities/MetaEntitiesEndPointLogic";
import SimpleBackdrop from "../../../../BackDrop/BackDrop";

interface OrganizationProps {
  open: boolean;
  handleClose: () => void;
  organizationName: any;
  setOrganizationName: any;
  organizationNumber: any;
  setOrganizationNumber: any;
  keeperFolderID: any;
  setKeeperFolderID: any;
  selectedShareuid: any;
  setSelectedSharedUid: any;
  selectedRowData: any;
  setSelectedRowData: any;
  setMetaOrganizations: any;
}

function EditOrganizationModal({
  open,
  handleClose,
  organizationName,
  setOrganizationName,
  organizationNumber,
  setOrganizationNumber,
  keeperFolderID,
  setKeeperFolderID,
  selectedShareuid,
  selectedRowData,
}: OrganizationProps) {
  const token = useSelector(setUserToken);
  const oauthTokenHeader = token?.payload?.user?.userToken;
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const UpdateOrganizationData = async () => {
    const data = {
      name: organizationName,
      organization_number: organizationNumber,
      keeper_folder_id: keeperFolderID,
    };
    try {
      setLoading(true);
      setIsLoading(true);
      if (oauthTokenHeader) {
        setIsLoading(true);
        await MetaEntitiesEndPointLogic.updateMetaOrganizations(
          oauthTokenHeader,
          data,
          selectedShareuid
        );
      } else {
        throw new Error("User doesn't have permissions to edit Organization");
      }
      if (oauthTokenHeader) {
        setIsLoading(true);
        await MetaEntitiesEndPointLogic.getMetaOrganizations(
          oauthTokenHeader,
          dispatch
        );
      }
    } catch (error) {
      console.error(error, "error");
    } finally {
      setLoading(false);
      setIsLoading(false);
      handleClose();
      await MetaEntitiesEndPointLogic.getMetaOrganizations(
        oauthTokenHeader,
        dispatch
      );
    }
  };

  useEffect(() => {
    if (oauthTokenHeader) {
      setOrganizationName(selectedRowData?.organization_name);
      setOrganizationNumber(selectedRowData?.organization_number);
      setKeeperFolderID(selectedRowData?.keeper_folder_id);
    }
  }, [
    oauthTokenHeader,
    setKeeperFolderID,
    setOrganizationName,
    setOrganizationNumber,
    selectedRowData,
  ]);

  return (
    <>
      {loading ? (
        <SimpleBackdrop />
      ) : (
        <Dialog
          open={open}
          onClose={handleClose}
          PaperProps={{ sx: { width: "900px", maxWidth: "900px" } }}
        >
          <Paper sx={{ padding: "16px 24px 20px 24px" }}>
            <DialogTitle sx={{ padding: "0px 0px 16px 0px" }}>
              Edit Organization
            </DialogTitle>
            <Typography sx={{ mb: 1 }}>Details</Typography>
            <Grid container mt={0} columnSpacing={3}>
              <Grid item xs={6}>
                <TextField
                  value={organizationName}
                  onChange={(e) => setOrganizationName(e.target.value)}
                  id="outlined-multiline-flexible"
                  label="Organization Name *" // Set your label here
                  placeholder="Enter unique Organization Name" // Set your placeholder here
                  color="secondary"
                  size="small"
                  fullWidth
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  value={organizationNumber}
                  onChange={(e) => setOrganizationNumber(e.target.value)}
                  id="outlined-multiline-flexible"
                  label="Organization Number *" // Set your label here
                  placeholder="Enter Organization Number" // Set your placeholder here
                  color="secondary"
                  size="small"
                  fullWidth
                />
              </Grid>
              <Grid item xs={6} sx={{ mt: 2 }}>
                <TextField
                  value={keeperFolderID}
                  onChange={(e) => setKeeperFolderID(e.target.value)}
                  id="outlined-multiline-flexible"
                  label="Keeper Folder ID *" // Set your label here
                  placeholder="Please Type with care" // Set your placeholder here
                  color="secondary"
                  size="small"
                  fullWidth
                />
              </Grid>
            </Grid>
            <Typography
              sx={{ fontSize: "12px", marginTop: "8px", color: "#00000099" }}
            >
              All fields are mandatory.
            </Typography>

            <Stack flexDirection={"row"} justifyContent={"end"} marginTop={2}>
              <Button color="secondary" onClick={handleClose} sx={{ mr: 1 }}>
                Cancel
              </Button>
              <Button
                variant="contained"
                color="secondary"
                disabled={
                  !organizationName || !organizationNumber || !keeperFolderID
                }
                onClick={UpdateOrganizationData}
                data-tracker="235"
              >
                Save changes <DoneIcon sx={{ ml: 1 }} />
              </Button>
            </Stack>
          </Paper>
        </Dialog>
      )}
    </>
  );
}

export default EditOrganizationModal;
